import { NAV_NAMES } from '../constants/nav-names';
import { NavLinkType } from './types';

export const SEARCH: NavLinkType = {
  menuName: NAV_NAMES.SEARCH,
  menuItems: [],
};
